export default __webpack_public_path__ + "static/media/Fall_04.9faa0fd3.png";